export default "__VITE_ASSET__CQyxWTDJ__"